(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('JobStream', JobStream);

    /* @ngInject */
    function JobStream($resource) {
        var resourceUrl = 'api/system/job-streams/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
